var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hero-section'),_c('pembinaan-section'),_c('announcement-section'),_c('benefit-section'),_c('faq-section'),_c('partner-section'),_c('join-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }